import React from "react"
import { withOktaAuth } from '@okta/okta-react';

class Logout extends React.Component {
    componentDidMount() {
        this.props.authService.logout();
    }

    render() {
        return null;
    }
}

export default withOktaAuth(Logout)